import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';

const RequisitionApproval = () => {



    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Requisition Approval"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [requitionApprovalListData, setRequitionApprovalListData] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = {
        RequisitionNo: { text: "Requisition No.", align: "start", visible: true },
        RequestedDate: { text: "Requested Date", align: "center", visible: true },
        Employee: { text: "Employee", align: "left", visible: true },
        Type: { text: "Type", align: "left", visible: true },
        Attachment: { text: "Attachment", align: "left", visible: true },
        Details: { text: "Details", align: "left", visible: true },


    };



    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className=" rounded bg-white" id="skill-table-area">
                    <div className="row mt-2">
                        <Dynamic_PR_table
                            data={requitionApprovalListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            showIcon1={true}
                            showIcon2={false}
                            isActionRequired={false}
                            isAddNewBtnRequired={true}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            // handleIcon1={handleEdit}
                            // handleAddNew={handleAddNewAssetReturn}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>

        </>
    )
}

export default RequisitionApproval